export enum EluateModelState {
	ACTIVE = 'ACTIVE',
	IN_WASTE_MANAGEMENT = 'IN_WASTE_MANAGEMENT'
}